import { render } from "./DetalleTarifarioModal.vue?vue&type=template&id=1ff5ee9f&scoped=true"
import script from "./DetalleTarifarioModal.vue?vue&type=script&lang=js"
export * from "./DetalleTarifarioModal.vue?vue&type=script&lang=js"

import "./DetalleTarifarioModal.vue?vue&type=style&index=0&id=1ff5ee9f&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff5ee9f"]])

export default __exports__